function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.86 15.14V8.3c-.2.21-.4.4-.62.59a124.9 124.9 0 00-4.54 3.61c-.2.14-.45.29-.78.43-.32.15-.63.22-.91.22h-.02c-.28 0-.59-.07-.91-.22a4.13 4.13 0 01-.78-.43 124.94 124.94 0 00-4.54-3.62 5.23 5.23 0 01-.62-.58v6.85c0 .08.03.15.09.2.05.06.12.09.2.09h13.14c.08 0 .15-.03.2-.09a.27.27 0 00.09-.2zm0-9.38V5.42l-.03-.1-.05-.09-.08-.06-.13-.03H3.43a.27.27 0 00-.2.09.27.27 0 00-.09.2c0 1 .44 1.84 1.32 2.53a1308.18 1308.18 0 014.7 3.71c.16.11.31.2.45.25.13.05.26.08.38.08h.02c.12 0 .25-.03.38-.08.14-.05.29-.14.45-.25a8.42 8.42 0 001.12-.88l3.58-2.83c.33-.25.63-.6.9-1.03.28-.43.42-.82.42-1.17zM18 5.43v9.71c0 .4-.14.73-.42 1.01-.28.28-.62.42-1 .42H3.42c-.4 0-.73-.14-1.01-.42a1.38 1.38 0 01-.42-1V5.42c0-.4.14-.73.42-1.01.28-.28.62-.42 1-.42h13.15c.4 0 .73.14 1.01.42.28.28.42.62.42 1z"
});

function SvgEnvelope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "#fff",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.df59f6fd.svg";
export { ForwardRef as ReactComponent };